var map = {
	"./further-mathematics-overview.ts": [
		80784,
		80784
	],
	"./h2-biology-cell-biomolecules.ts": [
		84902,
		84902
	],
	"./h2-biology-climate-change.ts": [
		97404,
		97404
	],
	"./h2-biology-energy-equilibrium.ts": [
		39391,
		39391
	],
	"./h2-biology-evolution.ts": [
		98927,
		98927
	],
	"./h2-biology-genetics-inheritance.ts": [
		89527,
		89527
	],
	"./h2-biology-infectious-diseases.ts": [
		93117,
		93117
	],
	"./h2-biology-practical-readiness.ts": [
		9208,
		9208
	],
	"./h2-chemistry-acids-bases.ts": [
		55094,
		55094
	],
	"./h2-chemistry-aqueous-solutions.ts": [
		53487,
		53487
	],
	"./h2-chemistry-atomic-structure.ts": [
		37772,
		37772
	],
	"./h2-chemistry-chemical-bonding.ts": [
		67643,
		67643
	],
	"./h2-chemistry-electrochemistry.ts": [
		15415,
		15415
	],
	"./h2-chemistry-energetics.ts": [
		3320,
		3320
	],
	"./h2-chemistry-equilibria.ts": [
		73756,
		73756
	],
	"./h2-chemistry-gaseous-state.ts": [
		50202,
		50202
	],
	"./h2-chemistry-kinetics.ts": [
		73533,
		73533
	],
	"./h2-chemistry-mole-concept.ts": [
		9819,
		9819
	],
	"./h2-chemistry-organic.ts": [
		6886,
		6886
	],
	"./h2-chemistry-periodic-table.ts": [
		12253,
		12253
	],
	"./h2-chemistry-practical-readiness.ts": [
		95773,
		95773
	],
	"./h2-chemistry-transition-elements": [
		39804,
		39804
	],
	"./h2-chemistry-transition-elements.ts": [
		39804,
		39804
	],
	"./h2-maths-argand-diagrams.ts": [
		48336,
		48336
	],
	"./h2-maths-calculus.ts": [
		88294,
		88294
	],
	"./h2-maths-complex-numbers.ts": [
		93641,
		93641
	],
	"./h2-maths-correlation-regression.ts": [
		31344,
		31344
	],
	"./h2-maths-definite-integrals.ts": [
		45750,
		45750
	],
	"./h2-maths-differential-equations.ts": [
		49933,
		49933
	],
	"./h2-maths-differentiation.ts": [
		62011,
		62011
	],
	"./h2-maths-discrete-rv.ts": [
		38708,
		38708
	],
	"./h2-maths-equations-inequalities.ts": [
		68535,
		68535
	],
	"./h2-maths-functions-graphs.ts": [
		80567,
		80567
	],
	"./h2-maths-functions.ts": [
		34247,
		34247
	],
	"./h2-maths-graphing-calculators.ts": [
		93502,
		93502
	],
	"./h2-maths-graphs-transformations.ts": [
		96080,
		96080
	],
	"./h2-maths-hypothesis-testing.ts": [
		4269,
		4269
	],
	"./h2-maths-integration-techniques.ts": [
		12304,
		12304
	],
	"./h2-maths-maclaurin-series.ts": [
		560,
		560
	],
	"./h2-maths-normal-distribution.ts": [
		54774,
		54774
	],
	"./h2-maths-probability-statistics.ts": [
		55451,
		55451
	],
	"./h2-maths-probability.ts": [
		3093,
		3093
	],
	"./h2-maths-pure-overview.ts": [
		75284,
		75284
	],
	"./h2-maths-sampling.ts": [
		28963,
		28963
	],
	"./h2-maths-scalar-vector-products": [
		10805,
		10805
	],
	"./h2-maths-scalar-vector-products.ts": [
		10805,
		10805
	],
	"./h2-maths-sequences-series-foundations.ts": [
		68721,
		68721
	],
	"./h2-maths-sequences-series.ts": [
		74022,
		74022
	],
	"./h2-maths-stats-overview.ts": [
		30303,
		30303
	],
	"./h2-maths-syllabus-2026.ts": [
		10670,
		10670
	],
	"./h2-maths-vector-geometry.ts": [
		32500,
		32500
	],
	"./h2-maths-vector-properties.ts": [
		21665,
		21665
	],
	"./h2-maths-vectors.ts": [
		49430,
		49430
	],
	"./h2-physics-circuits": [
		2352,
		2352
	],
	"./h2-physics-circuits.ts": [
		2352,
		2352
	],
	"./h2-physics-circular-motion.ts": [
		65434,
		65434
	],
	"./h2-physics-collisions.ts": [
		76433,
		76433
	],
	"./h2-physics-currents": [
		95562,
		95562
	],
	"./h2-physics-currents.ts": [
		95562,
		95562
	],
	"./h2-physics-electric-fields.ts": [
		94691,
		94691
	],
	"./h2-physics-electromagnetic-forces.ts": [
		12389,
		12389
	],
	"./h2-physics-electromagnetic-induction.ts": [
		33088,
		33088
	],
	"./h2-physics-energy-fields.ts": [
		5178,
		5178
	],
	"./h2-physics-forces-moments": [
		94556,
		94556
	],
	"./h2-physics-forces-moments.ts": [
		94556,
		94556
	],
	"./h2-physics-formulae-guide.ts": [
		3552,
		3552
	],
	"./h2-physics-gravitational-fields.ts": [
		65981,
		65981
	],
	"./h2-physics-motion-forces.ts": [
		75893,
		75893
	],
	"./h2-physics-nuclear-physics.ts": [
		50186,
		50186
	],
	"./h2-physics-oscillations.ts": [
		23196,
		23196
	],
	"./h2-physics-practical-readiness.ts": [
		48054,
		48054
	],
	"./h2-physics-projectile-energy.ts": [
		56358,
		56358
	],
	"./h2-physics-quantities-measurements": [
		74622,
		52241
	],
	"./h2-physics-quantities-measurements.ts": [
		74622,
		52241
	],
	"./h2-physics-quantum-physics.ts": [
		15697,
		15697
	],
	"./h2-physics-superposition.ts": [
		34960,
		34960
	],
	"./h2-physics-temperature-ideal-gases.ts": [
		47546,
		47546
	],
	"./h2-physics-thermodynamic-systems.ts": [
		30755,
		30755
	],
	"./h2-physics-wave-polarisation.ts": [
		93957,
		93957
	],
	"./h3-maths-overview.ts": [
		43376,
		43376
	],
	"./h3-vs-further-maths.ts": [
		52483,
		52483
	],
	"./ip-amaths-applications-of-differentiation.ts": [
		88981,
		88981
	],
	"./ip-amaths-binomial-theorem.ts": [
		20194,
		20194
	],
	"./ip-amaths-coordinate-geometry-lines.ts": [
		46025,
		46025
	],
	"./ip-amaths-differentiation-fundamentals.ts": [
		55566,
		55566
	],
	"./ip-amaths-differentiation-techniques.ts": [
		65869,
		65869
	],
	"./ip-amaths-indices-surds.ts": [
		92817,
		92817
	],
	"./ip-amaths-integration-essentials.ts": [
		96854,
		96854
	],
	"./ip-amaths-kinematics.ts": [
		10436,
		10436
	],
	"./ip-amaths-linear-law.ts": [
		70674,
		70674
	],
	"./ip-amaths-logarithms-exponentials.ts": [
		95841,
		95841
	],
	"./ip-amaths-modulus-functions.ts": [
		37419,
		37419
	],
	"./ip-amaths-overview.ts": [
		56169,
		56169
	],
	"./ip-amaths-parabolas-circles.ts": [
		73641,
		73641
	],
	"./ip-amaths-partial-fractions.ts": [
		70721,
		70721
	],
	"./ip-amaths-plane-geometry.ts": [
		83691,
		83691
	],
	"./ip-amaths-polynomials.ts": [
		15981,
		15981
	],
	"./ip-amaths-quadratic-functions.ts": [
		91272,
		91272
	],
	"./ip-amaths-simultaneous-equations.ts": [
		55397,
		55397
	],
	"./ip-amaths-standard-deviation.ts": [
		55973,
		55973
	],
	"./ip-amaths-trigonometry-1.ts": [
		87307,
		87307
	],
	"./ip-amaths-trigonometry-2.ts": [
		84798,
		84798
	],
	"./ip-biology-biological-molecules.ts": [
		50634,
		50634
	],
	"./ip-biology-cell-structure.ts": [
		87591,
		87591
	],
	"./ip-biology-ecology.ts": [
		33325,
		33325
	],
	"./ip-biology-excretion.ts": [
		44328,
		44328
	],
	"./ip-biology-homeostasis.ts": [
		37562,
		37562
	],
	"./ip-biology-infectious-diseases.ts": [
		86970,
		86970
	],
	"./ip-biology-inheritance.ts": [
		17397,
		17397
	],
	"./ip-biology-molecular-genetics.ts": [
		62314,
		62314
	],
	"./ip-biology-movement-substances.ts": [
		2434,
		2434
	],
	"./ip-biology-nutrition.ts": [
		49257,
		49257
	],
	"./ip-biology-plant-nutrition-transport.ts": [
		28829,
		28829
	],
	"./ip-biology-reproduction.ts": [
		12857,
		12857
	],
	"./ip-biology-respiration.ts": [
		25391,
		25391
	],
	"./ip-biology-transport.ts": [
		93592,
		93592
	],
	"./ip-chemistry-acid-base.ts": [
		39573,
		39573
	],
	"./ip-chemistry-air-quality.ts": [
		32816,
		32816
	],
	"./ip-chemistry-bonding-structure.ts": [
		18687,
		18687
	],
	"./ip-chemistry-calculations.ts": [
		96286,
		96286
	],
	"./ip-chemistry-energetics.ts": [
		99621,
		22002
	],
	"./ip-chemistry-experimental.ts": [
		22782,
		22782
	],
	"./ip-chemistry-organic.ts": [
		92073,
		92073
	],
	"./ip-chemistry-particulate-nature.ts": [
		40904,
		40904
	],
	"./ip-chemistry-periodic-table.ts": [
		14040,
		14040
	],
	"./ip-chemistry-qualitative-analysis.ts": [
		2664,
		2664
	],
	"./ip-chemistry-rate-of-reactions.ts": [
		4301,
		4301
	],
	"./ip-chemistry-redox.ts": [
		28536,
		28536
	],
	"./ip-emaths-algebraic-fractions-surds.ts": [
		75666,
		75666
	],
	"./ip-emaths-algebraic-tools.ts": [
		36420,
		36420
	],
	"./ip-emaths-coordinate-geometry.ts": [
		94015,
		94015
	],
	"./ip-emaths-functions-transformations.ts": [
		29016,
		29016
	],
	"./ip-emaths-indices-standard-form.ts": [
		58500,
		58500
	],
	"./ip-emaths-linear-equations-inequalities.ts": [
		37387,
		37387
	],
	"./ip-emaths-mensuration-3d-geometry.ts": [
		68446,
		68446
	],
	"./ip-emaths-probability.ts": [
		46609,
		46609
	],
	"./ip-emaths-quadratic-functions.ts": [
		58676,
		58676
	],
	"./ip-emaths-right-triangle-trig.ts": [
		46296,
		46296
	],
	"./ip-emaths-similarity-congruency.ts": [
		43951,
		43951
	],
	"./ip-emaths-simultaneous-equations.ts": [
		22265,
		22265
	],
	"./ip-emaths-statistics-data.ts": [
		20116,
		97735
	],
	"./ip-emaths-trig-applications.ts": [
		45532,
		45532
	],
	"./ip-emaths-upper-sec-overview.ts": [
		46290,
		46290
	],
	"./ip-emaths-variation-rate.ts": [
		8028,
		8028
	],
	"./ip-maths-algebraic-expressions-equations.ts": [
		94337,
		94337
	],
	"./ip-maths-coordinate-geometry.ts": [
		30808,
		30808
	],
	"./ip-maths-data-handling-statistics.ts": [
		49689,
		49689
	],
	"./ip-maths-geometry-congruency-similarity.ts": [
		83503,
		83503
	],
	"./ip-maths-lower-sec-overview.ts": [
		41216,
		41216
	],
	"./ip-maths-mensuration-circles.ts": [
		4582,
		4582
	],
	"./ip-maths-number-systems-indices.ts": [
		28749,
		28749
	],
	"./ip-maths-probability-models.ts": [
		69511,
		69511
	],
	"./ip-maths-quadratics-graphs.ts": [
		64898,
		64898
	],
	"./ip-maths-ratio-rate-percentage.ts": [
		22394,
		22394
	],
	"./ip-maths-trigonometry-right-triangles.ts": [
		33199,
		33199
	],
	"./ip-physics-crash-course.ts": [
		43554,
		43554
	],
	"./ip-physics-current-electricity.ts": [
		89934,
		89934
	],
	"./ip-physics-direct-current-circuits": [
		96611,
		96611
	],
	"./ip-physics-direct-current-circuits.ts": [
		96611,
		96611
	],
	"./ip-physics-electromagnetic-induction.ts": [
		93851,
		93851
	],
	"./ip-physics-electromagnetism.ts": [
		87860,
		87860
	],
	"./ip-physics-forces.ts": [
		80517,
		80517
	],
	"./ip-physics-formulae-guide.ts": [
		42253,
		42253
	],
	"./ip-physics-free-body-diagrams.ts": [
		72555,
		72555
	],
	"./ip-physics-kinematics.ts": [
		95655,
		95655
	],
	"./ip-physics-light-wa.ts": [
		84022,
		84022
	],
	"./ip-physics-light.ts": [
		20359,
		20359
	],
	"./ip-physics-magnetism.ts": [
		55322,
		55322
	],
	"./ip-physics-measurement-uncertainty.ts": [
		38270,
		38270
	],
	"./ip-physics-measurement.ts": [
		77555,
		77555
	],
	"./ip-physics-practical-electricity.ts": [
		76200,
		76200
	],
	"./ip-physics-practicals.ts": [
		80257,
		80257
	],
	"./ip-physics-pressure.ts": [
		48978,
		48978
	],
	"./ip-physics-radioactivity.ts": [
		81057,
		81057
	],
	"./ip-physics-static-electricity.ts": [
		74779,
		74779
	],
	"./ip-physics-suvat-variations.ts": [
		67153,
		67153
	],
	"./ip-physics-thermal.ts": [
		48808,
		48808
	],
	"./ip-physics-turning-forces.ts": [
		56585,
		56585
	],
	"./ip-physics-waves.ts": [
		28141,
		28141
	],
	"./ip-physics-work-energy-power.ts": [
		71507,
		71507
	],
	"./ip-school-topic-diagnostic.ts": [
		20069,
		20069
	],
	"./o-level-biology-sources-of-error.ts": [
		83143,
		83143
	],
	"./o-level-chemistry-practical-readiness.ts": [
		21607,
		21607
	],
	"app/components/quizzes/data/further-mathematics-overview.ts": [
		80784,
		80784
	],
	"app/components/quizzes/data/h2-biology-cell-biomolecules.ts": [
		84902,
		84902
	],
	"app/components/quizzes/data/h2-biology-climate-change.ts": [
		97404,
		97404
	],
	"app/components/quizzes/data/h2-biology-energy-equilibrium.ts": [
		39391,
		39391
	],
	"app/components/quizzes/data/h2-biology-evolution.ts": [
		98927,
		98927
	],
	"app/components/quizzes/data/h2-biology-genetics-inheritance.ts": [
		89527,
		89527
	],
	"app/components/quizzes/data/h2-biology-infectious-diseases.ts": [
		93117,
		93117
	],
	"app/components/quizzes/data/h2-biology-practical-readiness.ts": [
		9208,
		9208
	],
	"app/components/quizzes/data/h2-chemistry-acids-bases.ts": [
		55094,
		55094
	],
	"app/components/quizzes/data/h2-chemistry-aqueous-solutions.ts": [
		53487,
		53487
	],
	"app/components/quizzes/data/h2-chemistry-atomic-structure.ts": [
		37772,
		37772
	],
	"app/components/quizzes/data/h2-chemistry-chemical-bonding.ts": [
		67643,
		67643
	],
	"app/components/quizzes/data/h2-chemistry-electrochemistry.ts": [
		15415,
		15415
	],
	"app/components/quizzes/data/h2-chemistry-energetics.ts": [
		3320,
		3320
	],
	"app/components/quizzes/data/h2-chemistry-equilibria.ts": [
		73756,
		73756
	],
	"app/components/quizzes/data/h2-chemistry-gaseous-state.ts": [
		50202,
		50202
	],
	"app/components/quizzes/data/h2-chemistry-kinetics.ts": [
		73533,
		73533
	],
	"app/components/quizzes/data/h2-chemistry-mole-concept.ts": [
		9819,
		9819
	],
	"app/components/quizzes/data/h2-chemistry-organic.ts": [
		6886,
		6886
	],
	"app/components/quizzes/data/h2-chemistry-periodic-table.ts": [
		12253,
		12253
	],
	"app/components/quizzes/data/h2-chemistry-practical-readiness.ts": [
		95773,
		95773
	],
	"app/components/quizzes/data/h2-chemistry-transition-elements": [
		39804,
		39804
	],
	"app/components/quizzes/data/h2-chemistry-transition-elements.ts": [
		39804,
		39804
	],
	"app/components/quizzes/data/h2-maths-argand-diagrams.ts": [
		48336,
		48336
	],
	"app/components/quizzes/data/h2-maths-calculus.ts": [
		88294,
		88294
	],
	"app/components/quizzes/data/h2-maths-complex-numbers.ts": [
		93641,
		93641
	],
	"app/components/quizzes/data/h2-maths-correlation-regression.ts": [
		31344,
		31344
	],
	"app/components/quizzes/data/h2-maths-definite-integrals.ts": [
		45750,
		45750
	],
	"app/components/quizzes/data/h2-maths-differential-equations.ts": [
		49933,
		49933
	],
	"app/components/quizzes/data/h2-maths-differentiation.ts": [
		62011,
		62011
	],
	"app/components/quizzes/data/h2-maths-discrete-rv.ts": [
		38708,
		38708
	],
	"app/components/quizzes/data/h2-maths-equations-inequalities.ts": [
		68535,
		68535
	],
	"app/components/quizzes/data/h2-maths-functions-graphs.ts": [
		80567,
		80567
	],
	"app/components/quizzes/data/h2-maths-functions.ts": [
		34247,
		34247
	],
	"app/components/quizzes/data/h2-maths-graphing-calculators.ts": [
		93502,
		93502
	],
	"app/components/quizzes/data/h2-maths-graphs-transformations.ts": [
		96080,
		96080
	],
	"app/components/quizzes/data/h2-maths-hypothesis-testing.ts": [
		4269,
		4269
	],
	"app/components/quizzes/data/h2-maths-integration-techniques.ts": [
		12304,
		12304
	],
	"app/components/quizzes/data/h2-maths-maclaurin-series.ts": [
		560,
		560
	],
	"app/components/quizzes/data/h2-maths-normal-distribution.ts": [
		54774,
		54774
	],
	"app/components/quizzes/data/h2-maths-probability-statistics.ts": [
		55451,
		55451
	],
	"app/components/quizzes/data/h2-maths-probability.ts": [
		3093,
		3093
	],
	"app/components/quizzes/data/h2-maths-pure-overview.ts": [
		75284,
		75284
	],
	"app/components/quizzes/data/h2-maths-sampling.ts": [
		28963,
		28963
	],
	"app/components/quizzes/data/h2-maths-scalar-vector-products": [
		10805,
		10805
	],
	"app/components/quizzes/data/h2-maths-scalar-vector-products.ts": [
		10805,
		10805
	],
	"app/components/quizzes/data/h2-maths-sequences-series-foundations.ts": [
		68721,
		68721
	],
	"app/components/quizzes/data/h2-maths-sequences-series.ts": [
		74022,
		74022
	],
	"app/components/quizzes/data/h2-maths-stats-overview.ts": [
		30303,
		30303
	],
	"app/components/quizzes/data/h2-maths-syllabus-2026.ts": [
		10670,
		10670
	],
	"app/components/quizzes/data/h2-maths-vector-geometry.ts": [
		32500,
		32500
	],
	"app/components/quizzes/data/h2-maths-vector-properties.ts": [
		21665,
		21665
	],
	"app/components/quizzes/data/h2-maths-vectors.ts": [
		49430,
		49430
	],
	"app/components/quizzes/data/h2-physics-circuits": [
		2352,
		2352
	],
	"app/components/quizzes/data/h2-physics-circuits.ts": [
		2352,
		2352
	],
	"app/components/quizzes/data/h2-physics-circular-motion.ts": [
		65434,
		65434
	],
	"app/components/quizzes/data/h2-physics-collisions.ts": [
		76433,
		76433
	],
	"app/components/quizzes/data/h2-physics-currents": [
		95562,
		95562
	],
	"app/components/quizzes/data/h2-physics-currents.ts": [
		95562,
		95562
	],
	"app/components/quizzes/data/h2-physics-electric-fields.ts": [
		94691,
		94691
	],
	"app/components/quizzes/data/h2-physics-electromagnetic-forces.ts": [
		12389,
		12389
	],
	"app/components/quizzes/data/h2-physics-electromagnetic-induction.ts": [
		33088,
		33088
	],
	"app/components/quizzes/data/h2-physics-energy-fields.ts": [
		5178,
		5178
	],
	"app/components/quizzes/data/h2-physics-forces-moments": [
		94556,
		94556
	],
	"app/components/quizzes/data/h2-physics-forces-moments.ts": [
		94556,
		94556
	],
	"app/components/quizzes/data/h2-physics-formulae-guide.ts": [
		3552,
		3552
	],
	"app/components/quizzes/data/h2-physics-gravitational-fields.ts": [
		65981,
		65981
	],
	"app/components/quizzes/data/h2-physics-motion-forces.ts": [
		75893,
		75893
	],
	"app/components/quizzes/data/h2-physics-nuclear-physics.ts": [
		50186,
		50186
	],
	"app/components/quizzes/data/h2-physics-oscillations.ts": [
		23196,
		23196
	],
	"app/components/quizzes/data/h2-physics-practical-readiness.ts": [
		48054,
		48054
	],
	"app/components/quizzes/data/h2-physics-projectile-energy.ts": [
		56358,
		56358
	],
	"app/components/quizzes/data/h2-physics-quantities-measurements": [
		74622,
		52241
	],
	"app/components/quizzes/data/h2-physics-quantities-measurements.ts": [
		74622,
		52241
	],
	"app/components/quizzes/data/h2-physics-quantum-physics.ts": [
		15697,
		15697
	],
	"app/components/quizzes/data/h2-physics-superposition.ts": [
		34960,
		34960
	],
	"app/components/quizzes/data/h2-physics-temperature-ideal-gases.ts": [
		47546,
		47546
	],
	"app/components/quizzes/data/h2-physics-thermodynamic-systems.ts": [
		30755,
		30755
	],
	"app/components/quizzes/data/h2-physics-wave-polarisation.ts": [
		93957,
		93957
	],
	"app/components/quizzes/data/h3-maths-overview.ts": [
		43376,
		43376
	],
	"app/components/quizzes/data/h3-vs-further-maths.ts": [
		52483,
		52483
	],
	"app/components/quizzes/data/ip-amaths-applications-of-differentiation.ts": [
		88981,
		88981
	],
	"app/components/quizzes/data/ip-amaths-binomial-theorem.ts": [
		20194,
		20194
	],
	"app/components/quizzes/data/ip-amaths-coordinate-geometry-lines.ts": [
		46025,
		46025
	],
	"app/components/quizzes/data/ip-amaths-differentiation-fundamentals.ts": [
		55566,
		55566
	],
	"app/components/quizzes/data/ip-amaths-differentiation-techniques.ts": [
		65869,
		65869
	],
	"app/components/quizzes/data/ip-amaths-indices-surds.ts": [
		92817,
		92817
	],
	"app/components/quizzes/data/ip-amaths-integration-essentials.ts": [
		96854,
		96854
	],
	"app/components/quizzes/data/ip-amaths-kinematics.ts": [
		10436,
		10436
	],
	"app/components/quizzes/data/ip-amaths-linear-law.ts": [
		70674,
		70674
	],
	"app/components/quizzes/data/ip-amaths-logarithms-exponentials.ts": [
		95841,
		95841
	],
	"app/components/quizzes/data/ip-amaths-modulus-functions.ts": [
		37419,
		37419
	],
	"app/components/quizzes/data/ip-amaths-overview.ts": [
		56169,
		56169
	],
	"app/components/quizzes/data/ip-amaths-parabolas-circles.ts": [
		73641,
		73641
	],
	"app/components/quizzes/data/ip-amaths-partial-fractions.ts": [
		70721,
		70721
	],
	"app/components/quizzes/data/ip-amaths-plane-geometry.ts": [
		83691,
		83691
	],
	"app/components/quizzes/data/ip-amaths-polynomials.ts": [
		15981,
		15981
	],
	"app/components/quizzes/data/ip-amaths-quadratic-functions.ts": [
		91272,
		91272
	],
	"app/components/quizzes/data/ip-amaths-simultaneous-equations.ts": [
		55397,
		55397
	],
	"app/components/quizzes/data/ip-amaths-standard-deviation.ts": [
		55973,
		55973
	],
	"app/components/quizzes/data/ip-amaths-trigonometry-1.ts": [
		87307,
		87307
	],
	"app/components/quizzes/data/ip-amaths-trigonometry-2.ts": [
		84798,
		84798
	],
	"app/components/quizzes/data/ip-biology-biological-molecules.ts": [
		50634,
		50634
	],
	"app/components/quizzes/data/ip-biology-cell-structure.ts": [
		87591,
		87591
	],
	"app/components/quizzes/data/ip-biology-ecology.ts": [
		33325,
		33325
	],
	"app/components/quizzes/data/ip-biology-excretion.ts": [
		44328,
		44328
	],
	"app/components/quizzes/data/ip-biology-homeostasis.ts": [
		37562,
		37562
	],
	"app/components/quizzes/data/ip-biology-infectious-diseases.ts": [
		86970,
		86970
	],
	"app/components/quizzes/data/ip-biology-inheritance.ts": [
		17397,
		17397
	],
	"app/components/quizzes/data/ip-biology-molecular-genetics.ts": [
		62314,
		62314
	],
	"app/components/quizzes/data/ip-biology-movement-substances.ts": [
		2434,
		2434
	],
	"app/components/quizzes/data/ip-biology-nutrition.ts": [
		49257,
		49257
	],
	"app/components/quizzes/data/ip-biology-plant-nutrition-transport.ts": [
		28829,
		28829
	],
	"app/components/quizzes/data/ip-biology-reproduction.ts": [
		12857,
		12857
	],
	"app/components/quizzes/data/ip-biology-respiration.ts": [
		25391,
		25391
	],
	"app/components/quizzes/data/ip-biology-transport.ts": [
		93592,
		93592
	],
	"app/components/quizzes/data/ip-chemistry-acid-base.ts": [
		39573,
		39573
	],
	"app/components/quizzes/data/ip-chemistry-air-quality.ts": [
		32816,
		32816
	],
	"app/components/quizzes/data/ip-chemistry-bonding-structure.ts": [
		18687,
		18687
	],
	"app/components/quizzes/data/ip-chemistry-calculations.ts": [
		96286,
		96286
	],
	"app/components/quizzes/data/ip-chemistry-energetics.ts": [
		99621,
		22002
	],
	"app/components/quizzes/data/ip-chemistry-experimental.ts": [
		22782,
		22782
	],
	"app/components/quizzes/data/ip-chemistry-organic.ts": [
		92073,
		92073
	],
	"app/components/quizzes/data/ip-chemistry-particulate-nature.ts": [
		40904,
		40904
	],
	"app/components/quizzes/data/ip-chemistry-periodic-table.ts": [
		14040,
		14040
	],
	"app/components/quizzes/data/ip-chemistry-qualitative-analysis.ts": [
		2664,
		2664
	],
	"app/components/quizzes/data/ip-chemistry-rate-of-reactions.ts": [
		4301,
		4301
	],
	"app/components/quizzes/data/ip-chemistry-redox.ts": [
		28536,
		28536
	],
	"app/components/quizzes/data/ip-emaths-algebraic-fractions-surds.ts": [
		75666,
		75666
	],
	"app/components/quizzes/data/ip-emaths-algebraic-tools.ts": [
		36420,
		36420
	],
	"app/components/quizzes/data/ip-emaths-coordinate-geometry.ts": [
		94015,
		94015
	],
	"app/components/quizzes/data/ip-emaths-functions-transformations.ts": [
		29016,
		29016
	],
	"app/components/quizzes/data/ip-emaths-indices-standard-form.ts": [
		58500,
		58500
	],
	"app/components/quizzes/data/ip-emaths-linear-equations-inequalities.ts": [
		37387,
		37387
	],
	"app/components/quizzes/data/ip-emaths-mensuration-3d-geometry.ts": [
		68446,
		68446
	],
	"app/components/quizzes/data/ip-emaths-probability.ts": [
		46609,
		46609
	],
	"app/components/quizzes/data/ip-emaths-quadratic-functions.ts": [
		58676,
		58676
	],
	"app/components/quizzes/data/ip-emaths-right-triangle-trig.ts": [
		46296,
		46296
	],
	"app/components/quizzes/data/ip-emaths-similarity-congruency.ts": [
		43951,
		43951
	],
	"app/components/quizzes/data/ip-emaths-simultaneous-equations.ts": [
		22265,
		22265
	],
	"app/components/quizzes/data/ip-emaths-statistics-data.ts": [
		20116,
		97735
	],
	"app/components/quizzes/data/ip-emaths-trig-applications.ts": [
		45532,
		45532
	],
	"app/components/quizzes/data/ip-emaths-upper-sec-overview.ts": [
		46290,
		46290
	],
	"app/components/quizzes/data/ip-emaths-variation-rate.ts": [
		8028,
		8028
	],
	"app/components/quizzes/data/ip-maths-algebraic-expressions-equations.ts": [
		94337,
		94337
	],
	"app/components/quizzes/data/ip-maths-coordinate-geometry.ts": [
		30808,
		30808
	],
	"app/components/quizzes/data/ip-maths-data-handling-statistics.ts": [
		49689,
		49689
	],
	"app/components/quizzes/data/ip-maths-geometry-congruency-similarity.ts": [
		83503,
		83503
	],
	"app/components/quizzes/data/ip-maths-lower-sec-overview.ts": [
		41216,
		41216
	],
	"app/components/quizzes/data/ip-maths-mensuration-circles.ts": [
		4582,
		4582
	],
	"app/components/quizzes/data/ip-maths-number-systems-indices.ts": [
		28749,
		28749
	],
	"app/components/quizzes/data/ip-maths-probability-models.ts": [
		69511,
		69511
	],
	"app/components/quizzes/data/ip-maths-quadratics-graphs.ts": [
		64898,
		64898
	],
	"app/components/quizzes/data/ip-maths-ratio-rate-percentage.ts": [
		22394,
		22394
	],
	"app/components/quizzes/data/ip-maths-trigonometry-right-triangles.ts": [
		33199,
		33199
	],
	"app/components/quizzes/data/ip-physics-crash-course.ts": [
		43554,
		43554
	],
	"app/components/quizzes/data/ip-physics-current-electricity.ts": [
		89934,
		89934
	],
	"app/components/quizzes/data/ip-physics-direct-current-circuits": [
		96611,
		96611
	],
	"app/components/quizzes/data/ip-physics-direct-current-circuits.ts": [
		96611,
		96611
	],
	"app/components/quizzes/data/ip-physics-electromagnetic-induction.ts": [
		93851,
		93851
	],
	"app/components/quizzes/data/ip-physics-electromagnetism.ts": [
		87860,
		87860
	],
	"app/components/quizzes/data/ip-physics-forces.ts": [
		80517,
		80517
	],
	"app/components/quizzes/data/ip-physics-formulae-guide.ts": [
		42253,
		42253
	],
	"app/components/quizzes/data/ip-physics-free-body-diagrams.ts": [
		72555,
		72555
	],
	"app/components/quizzes/data/ip-physics-kinematics.ts": [
		95655,
		95655
	],
	"app/components/quizzes/data/ip-physics-light-wa.ts": [
		84022,
		84022
	],
	"app/components/quizzes/data/ip-physics-light.ts": [
		20359,
		20359
	],
	"app/components/quizzes/data/ip-physics-magnetism.ts": [
		55322,
		55322
	],
	"app/components/quizzes/data/ip-physics-measurement-uncertainty.ts": [
		38270,
		38270
	],
	"app/components/quizzes/data/ip-physics-measurement.ts": [
		77555,
		77555
	],
	"app/components/quizzes/data/ip-physics-practical-electricity.ts": [
		76200,
		76200
	],
	"app/components/quizzes/data/ip-physics-practicals.ts": [
		80257,
		80257
	],
	"app/components/quizzes/data/ip-physics-pressure.ts": [
		48978,
		48978
	],
	"app/components/quizzes/data/ip-physics-radioactivity.ts": [
		81057,
		81057
	],
	"app/components/quizzes/data/ip-physics-static-electricity.ts": [
		74779,
		74779
	],
	"app/components/quizzes/data/ip-physics-suvat-variations.ts": [
		67153,
		67153
	],
	"app/components/quizzes/data/ip-physics-thermal.ts": [
		48808,
		48808
	],
	"app/components/quizzes/data/ip-physics-turning-forces.ts": [
		56585,
		56585
	],
	"app/components/quizzes/data/ip-physics-waves.ts": [
		28141,
		28141
	],
	"app/components/quizzes/data/ip-physics-work-energy-power.ts": [
		71507,
		71507
	],
	"app/components/quizzes/data/ip-school-topic-diagnostic.ts": [
		20069,
		20069
	],
	"app/components/quizzes/data/o-level-biology-sources-of-error.ts": [
		83143,
		83143
	],
	"app/components/quizzes/data/o-level-chemistry-practical-readiness.ts": [
		21607,
		21607
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 75105;
module.exports = webpackAsyncContext;